<div class="container">
  <!-- Manage permissions Form-->
  <form
    [hidden]="loading"
    [formGroup]="createResourceForm"
    (ngSubmit)="submit()"
    class="pure-form pure-form-stacked"
  >
    <!-- Input for resourceName-->
    <label for="resourceName">Resource name </label>
    <input
      id="resourceName"
      class="pure-input-2-3"
      type="text"
      formControlName="resourceName"
    />

    <!-- Select option for resourceTypeName -->
    <label for="resourceTypeName">Resource type name</label>
    <select
      formControlName="resourceTypeName"
      id="resourceTypeName"
      class="pure-input-2-3"
    >
      <option
        *ngFor="let option of resourceTypeNameList; let i = index"
        [value]="option?.value"
      >
        {{ option?.label }}
      </option>
    </select>

    <!-- Select option for resourceNamespaceName -->
    <label for="resourceNamespaceName">Resource namespace</label>
    <select
      formControlName="resourceNamespaceName"
      id="resourceNamespaceName"
      class="pure-input-2-3"
    >
      <option
        *ngFor="let option of resourceNamespaceNameList; let i = index"
        [value]="option?.value"
      >
        {{ option?.label }}
      </option>
    </select>

    <!-- Select option for parentResourceId -->
    <label for="parentResourceId">Parent resource</label>
    <select
      formControlName="parentResourceId"
      id="parentResourceId"
      class="pure-input-2-3"
    >
      <option
        *ngFor="let option of parentResourceIdList; let i = index"
        [value]="option?.value"
      >
        {{ option?.label }}
      </option>
    </select>

    <!-- Submit button-->
    <div>
      <button
        class="pure-button pure-button-primary button-large"
        type="submit"
        [disabled]="createResourceForm.invalid"
      >
        Submit
      </button>
    </div>
  </form>
  <app-loader [loading]="loading" [size]="'small'"></app-loader>
</div>
